import ButtonComponent from "../../../components/common/button/Button"
import Modal from "../../../components/common/modal/Modal";
import './CopyPasteDateRowsModal.css';
import CircularProgress from '@mui/material/CircularProgress';

const CopyPasteDateRows = ({ openCopyPasteModal, copyPasteSelectedRowData, handleCloseCopyPasteModal, handleCopyPasteConfirmation, loadingCopyPaste }) => {
   
    const onCloseCopyPasteModal = () => {
        handleCloseCopyPasteModal();
    }
    const onClickCancel = () => {
        handleCloseCopyPasteModal();
    }
    const onClickYes = () => {
        handleCopyPasteConfirmation();
    }
    return (
        <div>
            <Modal
                className="CopyPasteDateRowsModal_cls"
                open={openCopyPasteModal}
                handleClose={onCloseCopyPasteModal}
                title="Confirm Action"
                fullWidth={true}
                action={
                    <CopyPasteModalFooter
                        onClickCancel={onClickCancel}
                        onClickYes={onClickYes}
                        loadingCopyPaste={loadingCopyPaste}
                    />
                }
                content={
                    <CopyPasteModalContent
                        onClickCancel={onClickCancel}
                        copyPasteSelectedRowData={copyPasteSelectedRowData}
                    />
                }
            />
        </div>
    )
}
const CopyPasteModalFooter = ({ onClickCancel, onClickYes, loadingCopyPaste }) => {
    return (
        <div className='btn-wrapper' style={{ display: 'flex', gap: 10 }}>
            <ButtonComponent
                label="No"
                type="primary"
                maxWidth="80px"
                onClick={onClickCancel}
            />
            <ButtonComponent
                label={
                    loadingCopyPaste ? (
                        <span style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                            <CircularProgress size={16}  />
                        </span>
                    ) : (
                        "Yes"
                    )
                }
                type="secondary"
                maxWidth="80px"
                onClick={onClickYes}
                disabled={loadingCopyPaste}
            />

        </div>
    );
};
const CopyPasteModalContent = ({ copyPasteSelectedRowData }) => {
    return (
        <div className='finalLTupdatedfooter-btn-wrapper'>
            <p>Do you want to copy forecast data into the confirmation fields?</p>
        </div>
    );
};

export default CopyPasteDateRows;